export const CARD_AD_TEST_ID = 'list-related-ads-item'

export const ITEMS_PER_ROW = [3, 4, 6]
export const ITEMS_PER_ROW_WIDTH = {
  2: 'l',
  3: 'l',
  4: 'm',
  5: 'm',
  6: 's',
  7: 's',
  8: 's'
}

export const [defaultItemsPerRow] = ITEMS_PER_ROW

export const DISPLAY = {
  grid: 'grid',
  scrolling: 'scrolling',
  slides: 'slides'
}

export const DEFAULT_MAX_ITEMS = 4
